import { useToast } from "@/hooks/use-toast";
import {
  horoscopeService,
  type HoroscopeSign,
} from "@/lib/api/horoscope.service";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";

export const HOROSCOPE_SIGNS_QUERY_KEY = ["/horoscope/signs"];

interface UseHoroscopeSignsOptions {
  language?: string;
}

export function useHoroscopeSigns(options: UseHoroscopeSignsOptions = {}) {
  const { language = "en" } = options;

  return useQuery<HoroscopeSign[]>({
    queryKey: [...HOROSCOPE_SIGNS_QUERY_KEY, language],
    queryFn: () => horoscopeService.getSigns(language),
    retry: false,
  });
}

export function useUpdateHoroscopeSign(language: string = "en") {
  const queryClient = useQueryClient();
  const { toast } = useToast();

  return useMutation({
    mutationFn: ({ id, file }: { id: string; file: File }) =>
      horoscopeService.updateSign(id, file),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [...HOROSCOPE_SIGNS_QUERY_KEY, language],
      });
      toast({ title: "Zodiac sign background updated" });
    },
    onError: (err: Error) => {
      toast({
        title: err.message || "Failed to update sign",
        variant: "destructive",
      });
    },
  });
}
